import { useCallback } from 'react';
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { STORE_PREFIX } from 'constants/globals';

const useStore = create(
  persist(
    set => ({
      schedaDifettiTrigger: null,
      setSchedaDifettiTrigger: value =>
        set(() => ({ schedaDifettiTrigger: value })),
      inspectionLevelTab: null,
      setInspectionLevelTab: newValue =>
        set(() => ({ inspectionLevelTab: newValue })),
      inspectionLevelSubTab: null,
      setInspectionLevelSubTab: newValue =>
        set(() => ({ inspectionLevelSubTab: newValue })),
      inspectionLevelSubTabAccordion: null,
      setInspectionLevelSubTabAccordion: newValue =>
        set(() => ({ inspectionLevelSubTabAccordion: newValue })),
      inspectionDisabled: null,
      setInspectionDisabled: newValue =>
        set(() => ({ inspectionDisabled: newValue })),
      // Task 18 — canEdit di l3Access del ponte corrente (proprietà del
      // PROPRIETARIO del ponte, non dell'utente loggato), letto da
      // useInspection.js e consumato dove serve gatare qualcosa di
      // L3-correlato SENZA che l'intera inspection sia in sola lettura
      // (es. lo switch "Tipologia di calcolo" su un'attività L0/1/2
      // normale) — vedi
      // apps/web-bo/plans/features/l3/task-18-l3-condivisione-handoff-fe.md.
      // null finché l3Access non è ancora arrivato dalla GET.
      l3ModuleCanEdit: null,
      setL3ModuleCanEdit: newValue =>
        set(() => ({ l3ModuleCanEdit: newValue })),
      version: null,
      setVersion: newValue => set(() => ({ version: newValue })),
    }),

    {
      name: `${STORE_PREFIX}inspection`,
      getStorage: () => sessionStorage,
      partialize: state =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                'schedaDifettiTrigger',
                'inspectionDisabled',
                'l3ModuleCanEdit',
                'inspectionLevelTab',
                'inspectionLevelSubTab',
                'inspectionLevelSubTabAccordion',
              ].includes(key)
          )
        ),
    }
  )
);

const useInspectionSelector = () => useStore(useCallback(state => state, []));

export { useInspectionSelector, useStore as useInspectionStore };
